import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "password-strength" }
const _hoisted_2 = {
  key: 0,
  class: "password-strength__suggestions"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title is-4" }, "Password requirements", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "TIP: consider using a passphrase!", -1)
const _hoisted_7 = { for: "password-strength" }
const _hoisted_8 = {
  id: "password-strength",
  class: "custom-progress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showPasswordSuggestions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  class: _normalizeClass({ active: _ctx.hasAtLeast8Characters })
                }, "Use at least 8 characters", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ active: _ctx.hasLowerCase && _ctx.hasUpperCase })
                }, "Use upper and lower case characters", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ active: _ctx.hasNumberCharacter })
                }, "Use 1 or more numbers", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ active: _ctx.hasSpecialCharacter })
                }, "Optionally: use special characters", 2)
              ]),
              _hoisted_5,
              _hoisted_6
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("label", _hoisted_7, "Password strength: " + _toDisplayString(_ctx.strength), 1),
    _createElementVNode("span", _hoisted_8, [
      _createElementVNode("span", {
        class: _normalizeClass(["custom-progress__value", _ctx.strength]),
        style: _normalizeStyle(`transform: scaleX(${_ctx.percentage * 0.01})`)
      }, _toDisplayString(_ctx.percentage) + "% ", 7)
    ])
  ]))
}